import * as React from 'react'

function ImageHeader(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={304}
      height={218}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.822 67.293l48.99-39.978L41.8 60.38S57.863-4.1 118.777 17.695c-.014.015-9.373 67.737-63.955 49.598zM78.57 183.583l-55.687-29.242 54.82 43.9s-64.177 10.625-69.512-53.84c0 .015 64.356-18.036 70.38 39.182zM303.531 0H278.55c-10.557 20.31-25.312 39.07-43.485 54.884-32.689 28.427-75.68 47.323-124.308 54.644-.45.075-.9.166-1.335.301-4.873 1.338-8.232 5.803-8.232 10.839 0 .556.03 1.112.12 1.683.93 6.164 6.658 10.403 12.791 9.486a308.087 308.087 0 0023.452-4.465c43.29-9.982 81.752-28.923 112.252-55.456C273.182 51.592 291.52 26.803 303.531 0z"
        fill="#1978B2"
      />
      <path
        d="M21.855 0h.83c-.724 31.884 4.082 61.045 24.75 78.721 9.707 8.294 22.217 13.27 35.451 18.533l.102.04c4.353 1.735 8.842 3.515 13.241 5.429a225.378 225.378 0 0113.709 6.535 221.204 221.204 0 0141.337 27.726c22.944 19.471 43.104 58.748 48.995 81.016h-23.162c-4.715-17.766-21.133-47.518-40.521-63.953a198.714 198.714 0 00-49.427-30.776c-4.067-1.765-8.195-3.41-12.563-5.145-14.417-5.727-29.316-11.649-41.895-22.417C6.972 73.726.012 41.11.012 5.907c0-.897-.03-4.994 0-5.907h21.843z"
        fill="#1978B2"
      />
    </svg>
  )
}

export default ImageHeader
